// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__XqBMd","title":"Checkout_title__qq12Z","actions":"Checkout_actions__IVYSE"};